import marketingInstance from './instance'

const getCoupon = (couponId) => {
  return marketingInstance.get(`/coupons/${couponId}`)
}

export default getCoupon
